import type { TrigExperimentDef, ExperimentKey } from '../types';
import { mountRightTriangle } from './right-triangle';
import { mountUnitCircle } from './unit-circle';
import { mountWaveStudio } from './wave-studio';
import { mountIdentityPlayground } from './identity-playground';
import { mountTriangleSolver } from './triangle-solver';
import { mountCircularPolar } from './circular-polar';

export const EXPERIMENTS: Record<ExperimentKey, TrigExperimentDef> = {
  'right-triangle': {
    labelKey: 'experiment.right-triangle.label',
    params: [],
    mount: mountRightTriangle,
  },
  'unit-circle': {
    labelKey: 'experiment.unit-circle.label',
    params: [],
    mount: mountUnitCircle,
  },
  'wave-studio': {
    labelKey: 'experiment.wave-studio.label',
    params: [],
    mount: mountWaveStudio,
  },
  'identity-playground': {
    labelKey: 'experiment.identity-playground.label',
    params: [],
    mount: mountIdentityPlayground,
  },
  'triangle-solver': {
    labelKey: 'experiment.triangle-solver.label',
    params: [],
    mount: mountTriangleSolver,
  },
  'circular-polar': {
    labelKey: 'experiment.circular-polar.label',
    params: [],
    mount: mountCircularPolar,
  },
};
